import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ActionTypes } from '../actions/app';
export var uploadConfig = {
  averageDuration: 104,
  extensions: ['.docx', '.txt'],
  filesize: {
    min: 0,
    max: 20971520
  },
  mimeTypes: ['application/vnd.google-apps.document', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain']
};
export var initialState = {
  initialized: false,
  upload: uploadConfig,
  // bypass googledocs configuration if `pasteOnly` === true
  pasteOnly: false,
  initRSW: true,
  initFreshToken: false,
  checkCategory: null
};
var app = function app() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.APP_INITIALIZING:
      return _objectSpread(_objectSpread({}, state), {}, {
        initialized: false
      });
    case ActionTypes.APP_INITIALIZED:
      return _objectSpread(_objectSpread({}, state), {}, {
        initialized: true
      });
    default:
      return state;
  }
};
export default app;